import React, { Component, Fragment } from "react";
import { translate } from "react-i18next";
import { request } from "./../../../../config";
import $ from "jquery";
// import Loading from '../../../../../Loading/Loading';
import OutsideClickHandler from "react-outside-click-handler";
import currencyFilter from "../../../../helpers/currencyFilter";
import transferConfirmation from "../../img/last-operations-icon.png";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  Cell,
} from "recharts";
import { Tooltip, PieChart, Pie, Cell as PieCell } from "recharts";
import DateRangeModal from "./DateRangeModal";
import { getFormatedDate } from "../../../../helpers/fotmatDate";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import Loading from "./../../Loading/Loading";
import AllCategories from "./AllCategories";

class JuridicalStatistics extends Component {
  state = {
    account: null,
    operationDirection: "EXPENSE", // or INCOME

    // these dates set for existing data
    // toDate: new Date(2023, 0, 1),
    // fromDate: new Date(2022, 1, 1),

    // to be replaced with date range picker
    toDate: new Date(),
    fromDate: (() => {
      const date = new Date();
      date.setDate(date.getDate() - 30); // last 30 days
      return date;
    })(),
    
    isDateRangeModalOpen: false,
    totalBarAmount: 0,
    barData: [],
    donutData: [],
    allCategories: [],
  };
  
  updateDate = (name, value) => {
    this.setState({ [name]: value });
  };

  openDateRangeModal = () => {
    this.setState({ isDateRangeModalOpen: true });
  };

  closeDateRangeModal = () => {
    this.setState({ isDateRangeModalOpen: false });
  };

  handleDateRangeConfirm = ({ startDate, endDate }) => {
    this.setState(
      {
        fromDate: startDate,
        toDate: endDate,
        isDateRangeModalOpen: false,
      },
      this.getExpenceOrIncomeSeparatelyPerCategory,
    );
  };

  showAccount = () => {
    this.setState({ isLoading: true });
    let customerType =
      localStorage.getItem("compId") === null ? "Individual" : "Juridical";
    let getAccountByIdForCustomerRequestBody =
      customerType == "Juridical"
        ? {
            custId: localStorage.getItem("custId"),
            compId: localStorage.getItem("compId"),
            token: localStorage.getItem("token"),
            accountId: this.props.match.params.id,
            lang: localStorage.getItem("i18nextLng").toUpperCase(),
          }
        : {
            custId: localStorage.getItem("custId"),
            token: localStorage.getItem("token"),
            accountId: this.props.match.params.id,
            lang: localStorage.getItem("i18nextLng").toUpperCase(),
          };

    fetch(
      request(
        "account/getAccountByIdFor" + customerType + "Customer",
        getAccountByIdForCustomerRequestBody,
      ),
    )
      .then((res) => res.text())
      .then(
        (getAccountByIdForCustomerResponseJSON) => {
          const JSON = require("true-json-bigint");
          let getAccountByIdForCustomerResponse = JSON.parse(
            getAccountByIdForCustomerResponseJSON,
          );
          if (getAccountByIdForCustomerResponse.status.statusCode !== 1) {
            if (getAccountByIdForCustomerResponse.status.statusCode === 200) {
              this.props.logout();
            } else {
              this.setState({ isLoading: false });
            }
          } else {
            // =========CURRENCY=========
            getAccountByIdForCustomerResponse.currencyIcon = currencyFilter(
              getAccountByIdForCustomerResponse.currName,
            );
            // =========BALANCE=========
            if (
              getAccountByIdForCustomerResponse.currentBalance.toString() ===
              "0"
            ) {
              getAccountByIdForCustomerResponse.organizedCurrentBalance = {
                wholePart: "0",
                fractionalPart: "00",
              };
            } else {
              if (
                getAccountByIdForCustomerResponse.currentBalance
                  .toString()
                  .indexOf(".") !== -1
              ) {
                let currentBalanceArray =
                  getAccountByIdForCustomerResponse.currentBalance
                    .toString()
                    .split(".");
                getAccountByIdForCustomerResponse.organizedCurrentBalance = {
                  wholePart: currentBalanceArray[0],
                  fractionalPart:
                    currentBalanceArray[1].length === 1
                      ? currentBalanceArray[1] + "0"
                      : currentBalanceArray[1],
                };
              } else {
                getAccountByIdForCustomerResponse.organizedCurrentBalance = {
                  wholePart:
                    getAccountByIdForCustomerResponse.currentBalance.toString(),
                  fractionalPart: "00",
                };
              }
            }
            this.setState({ account: getAccountByIdForCustomerResponse });
            // this.showStatements(new Date(), new Date(), true);
          }
        },
        (error) => {
          this.props.history.push("/technical-break");
        },
      );
  };

  getExpenceOrIncomeSeparatelyPerCategory = () => {
    this.setState({ isLoading: true });

    let getExpensesRequestBody = {
      token: localStorage.getItem("token"),
      accountId: this.props.match.params.id,
      lang: localStorage.getItem("i18nextLng").toUpperCase(),
      toDate: getFormatedDate(this.state.toDate, "-"),
      fromDate: getFormatedDate(this.state.fromDate, "-"),
      operationDirection: this.state.operationDirection,
    };

    fetch(request("account/expense", getExpensesRequestBody))
      .then((res) => res.text())
      .then(
        (getExpensesResponseJSON) => {
          const JSON = require("true-json-bigint");
          let getExpensesResponse = JSON.parse(getExpensesResponseJSON);
          if (getExpensesResponse.status.statusCode !== 1) {
            if (getExpensesResponse.status.statusCode === 200) {
              this.props.logout();
            } else {
              this.setState({ isLoading: false });
            }
          } else {
            const barData = getExpensesResponse.expenseStatistics.map(
              (item) => ({
                id: item.categoryId,
                category: item.categoryName,
                label: ` (${item.percentage})`,
                value: item.amount,
                amountString: item.amountString,
                percentage: item.percentage,
                color: item.colorHex,
              }),
            );
            this.setState({
              barData: barData,
              totalBarAmount: getExpensesResponse.totalAmount,
              isLoading: false,
            });
          }
        },
        (error) => {
          this.props.history.push("/technical-break");
        },
      );
  };

  getExpenceOrIncomeComparison = () => {
    const { t } = this.props;
    this.setState({ isLoading: true });

    let getExpensesRequestBody = {
      token: localStorage.getItem("token"),
      accountId: this.props.match.params.id,
      lang: localStorage.getItem("i18nextLng").toUpperCase(),
      toDate: getFormatedDate(this.state.toDate, "-"),
      fromDate: getFormatedDate(this.state.fromDate, "-"),
    };

    fetch(request("account/income-expense", getExpensesRequestBody))
      .then((res) => res.text())
      .then(
        (getExpensesResponseJSON) => {
          const JSON = require("true-json-bigint");
          let getExpensesResponse = JSON.parse(getExpensesResponseJSON);
          if (getExpensesResponse.status.statusCode !== 1) {
            if (getExpensesResponse.status.statusCode === 200) {
              this.props.logout();
            } else {
              this.setState({ isLoading: false });
            }
          } else {
            const parsePercentage = (val) =>
              parseFloat(val.replace("%", "").trim());

            const donutData = [
              {
                name: t("Income"),
                // value: parsePercentage(getExpensesResponse.incomeExpense.incomePercentage),
                value: getExpensesResponse.incomeExpense.incomePercentage,
                color: getExpensesResponse.incomeExpense.incomeColorHex,
                amount: getExpensesResponse.incomeExpense.incomeAmount,
              },
              {
                name: t("Outcome"),
                // value: parsePercentage(getExpensesResponse.incomeExpense.expensePercentage),
                value: getExpensesResponse.incomeExpense.expensePercentage,
                color: getExpensesResponse.incomeExpense.expenseColorHex,
                amount: getExpensesResponse.incomeExpense.expenseAmount,
              },
            ];

            this.setState({
              donutData: donutData,
              isLoading: false,
            });
          }
        },
        (error) => {
          this.props.history.push("/technical-break");
        },
      );
  };

  componentDidMount() {
    if (!this.props.location.state?.pageIsAvailable) {
      this.props.history.push("/dashboard/finance/accounts");
    }

    this.showAccount();
    this.getExpenceOrIncomeSeparatelyPerCategory();
    this.getExpenceOrIncomeComparison();
  }

  render() {
    let { t, history } = this.props;
    let { isLoading, account, totalBarAmount, barData, donutData } = this.state;

    return (
      <Fragment>
        <div className="dashboard-header-route">
          <div className="dashboard-header-route-left">
            <button onClick={() => this.props.history.goBack()}>
              <svg
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.7344 21.2188L12.6719 20.3281C12.9062 20.0938 12.9062 19.7188 12.6719 19.5312L5.40625 12.2188H21.4375C21.7188 12.2188 22 11.9844 22 11.6562V10.3438C22 10.0625 21.7188 9.78125 21.4375 9.78125H5.40625L12.6719 2.51562C12.9062 2.32812 12.9062 1.95312 12.6719 1.71875L11.7344 0.828125C11.5469 0.59375 11.1719 0.59375 10.9375 0.828125L1.14062 10.625C0.90625 10.8594 0.90625 11.1875 1.14062 11.4219L10.9375 21.2188C11.1719 21.4531 11.5469 21.4531 11.7344 21.2188Z"
                  fill="#2E3131"
                />
              </svg>
            </button>
            <h2>
              {account
                ? account.accountName && account.accountName
                : t("accounts")}
            </h2>
          </div>
        </div>
        {isLoading ? (
          <div className="dashboard-container-main-section">
            <Loading />
          </div>
        ) : (
          <>
            <div className="dashboard-payment-container">
              <div className="dashboard-payment-container-data-section">
                <div className="dashboard-transfer-list-header">
                  <div className="dashboard-transfer-list-header-container dashboard-transfer-list-header-container__left">
                    <button
                      onClick={() =>
                        this.setState(
                          { operationDirection: "EXPENSE" },
                          this.getExpenceOrIncomeSeparatelyPerCategory,
                        )
                      }
                      className={`dashboard-transfer-list-header-link ${this.state.operationDirection === "EXPENSE" ? "dashboard-transfer-list-header-container dashboard-transfer-list-header-link__active" : ""}`}
                    >
                      {t("expenses")}
                    </button>
                    <button
                      onClick={() =>
                        this.setState(
                          { operationDirection: "INCOME" },
                          this.getExpenceOrIncomeSeparatelyPerCategory,
                        )
                      }
                      className={`dashboard-transfer-list-header-link ${this.state.operationDirection === "INCOME" ? "dashboard-transfer-list-header-container dashboard-transfer-list-header-link__active" : ""}`}
                    >
                      {t("incomes")}
                    </button>
                  </div>
                </div>
                <div className="dashboard-payment-container-data-section-content p-4">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: 24,
                      flexWrap: "wrap",
                      gap: 16,
                    }}
                  >
                    <div>
                      <h3 className="dashboard-payment-container-data-section-content-title">
                        {t("Expense overview")}
                      </h3>
                      <p className="registration-container-description">
                        {t("Track and analyze your expenses")}
                      </p>
                    </div>
                    <div className="dashboard-account-container-component align-items-end">
                      <div
                        style={{
                          position: "relative",
                          display: "inline-block",
                        }}
                      >
                        <CalendarTodayOutlinedIcon
                          style={{
                            position: "absolute",
                            left: 10,
                            top: "50%",
                            transform: "translateY(-50%)",
                            color: "#888",
                            pointerEvents: "none",
                            fontSize: 18,
                          }}
                        />

                        <input
                          type="text"
                          placeholder="Select date range"
                          value={
                            this.state.fromDate && this.state.toDate
                              ? `${getFormatedDate(this.state.fromDate, ".")} - ${getFormatedDate(this.state.toDate, ".")}`
                              : ""
                          }
                          onClick={this.openDateRangeModal}
                          readOnly
                          style={{
                            padding: "8px 12px 8px 36px",
                            border: "1px solid #e0e0e0",
                            borderRadius: "4px",
                            cursor: "pointer",
                            fontSize: "14px",
                          }}
                        />
                      </div>

                      <DateRangeModal
                        isOpen={this.state.isDateRangeModalOpen}
                        onClose={this.closeDateRangeModal}
                        onConfirm={this.handleDateRangeConfirm}
                        initialStartDate={this.state.fromDate}
                        initialEndDate={this.state.toDate}
                        t={t}
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexWrap: "wrap",
                      alignItems: "center",
                      gap: 24,
                    }}
                  >
                    {/* LEFT: Bar Chart */}
                    <div
                      style={{
                        flex: "1 1 400px",
                        minWidth: 280,
                        background: "#fff",
                        borderRadius: 16,
                        padding: "24px 8px",
                        boxShadow: "0 2px 12px rgba(0,0,0,0.07)",
                        fontFamily: "'Segoe UI', sans-serif",
                        height: 350,
                      }}
                    >
                      <div
                        style={{ fontSize: 11, color: "#888", marginBottom: 2 }}
                      >
                        {this.state.operationDirection === "EXPENSE" ? t("total expenses") : t("total incomes")}
                      </div>
                      <div
                        style={{
                          fontSize: 26,
                          fontWeight: 700,
                          color: "#1a1a1a",
                          marginBottom: 16,
                        }}
                      >
                        {totalBarAmount ?? 0}
                      </div>
                      <ResponsiveContainer width="100%" height={200}>
                        <BarChart
                          data={barData}
                          barCategoryGap="18%"
                          margin={{ top: 8, right: 0, left: -10, bottom: 10 }}
                        >
                          <CartesianGrid vertical={false} stroke="#f0f0f0" />
                          <XAxis
                            dataKey="label"
                            axisLine={false}
                            tickLine={false}
                            height={20}
                            tick={{
                              fontSize: 11,
                              fill: "#aaa",
                              angle: 0,
                              textAnchor: "end",
                            }}
                          />

                          <YAxis
                            axisLine={false}
                            tickLine={false}
                            tick={{ fontSize: 9, fill: "#aaa" }}
                            tickFormatter={(v) =>
                              v === 0 ? "0k" : `${v / 1000}k`
                            }
                            domain={[0, 4000]}
                            ticks={[0, 1000, 2000, 3000, 4000]}
                          />
                          <Tooltip
                            formatter={(value, name, props) => [
                              `${t("Amount")}: ${props.payload.amount}`,
                              `$}t("Value)`,
                            ]}
                            labelFormatter={(label) => label}
                            content={({ active, payload }) => {
                              if (active && payload && payload[0]) {
                                const data = payload[0].payload;
                                return (
                                  <div
                                    style={{
                                      backgroundColor: "#fff",
                                      border: "1px solid #ccc",
                                      borderRadius: "4px",
                                      padding: "8px 12px",
                                      fontSize: "12px",
                                    }}
                                  >
                                    <p
                                      style={{
                                        margin: "0 0 4px 0",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {data.category}
                                    </p>
                                    <p style={{ margin: "0 0 4px 0" }}>
                                      {t("Amount")}: {data.amountString}
                                    </p>
                                    <p style={{ margin: "0", color: "#666" }}>
                                      {t("Percentage")}: {data.percentage}
                                    </p>
                                  </div>
                                );
                              }
                              return null;
                            }}
                          />
                          <Bar
                            dataKey="value"
                            radius={[10, 10, 0, 0]}
                            isAnimationActive={true}
                          >
                            {barData.map((entry, index) => (
                              <Cell key={index} fill={entry.color} />
                            ))}
                          </Bar>
                        </BarChart>
                      </ResponsiveContainer>
                    </div>

                    {/* RIGHT: Donut Chart + Legend */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 16,
                        flex: "1 1 220px",
                        justifyContent: "center",
                        background: "#fff",
                        borderRadius: 16,
                        padding: "24px 8px",
                        boxShadow: "0 2px 12px rgba(0,0,0,0.07)",
                        fontFamily: "'Segoe UI', sans-serif",
                        height: 350,
                      }}
                    >
                      <ResponsiveContainer width="100%" height="100%">
                        <PieChart>
                          <Tooltip
                            formatter={(value, name, props) => [
                              `${t("Amount")}: ${props.payload.amount}`,
                              `$}t("Value)`,
                            ]}
                            labelFormatter={(label) => label}
                            content={({ active, payload }) => {
                              if (active && payload && payload[0]) {
                                const data = payload[0].payload;
                                return (
                                  <div
                                    style={{
                                      backgroundColor: "#fff",
                                      border: "1px solid #ccc",
                                      borderRadius: "4px",
                                      padding: "8px 12px",
                                      fontSize: "12px",
                                    }}
                                  >
                                    <p style={{ margin: "0 0 4px 0" }}>
                                      {t("Amount")}: {data.amount}
                                    </p>
                                    <p style={{ margin: "0", color: "#666" }}>
                                      {t("Percentage")}: {data.value}%
                                    </p>
                                  </div>
                                );
                              }
                              return null;
                            }}
                          />
                          <Pie
                            data={donutData}
                            cx="50%"
                            cy="50%"
                            innerRadius="35%"
                            outerRadius="80%"
                            startAngle={90}
                            endAngle={-270}
                            paddingAngle={2}
                            dataKey="value"
                            cornerRadius={10}
                            isAnimationActive={true}
                          >
                            {donutData.map((entry, index) => (
                              <PieCell
                                key={index}
                                fill={entry.color}
                                stroke="none"
                              />
                            ))}
                          </Pie>
                        </PieChart>
                      </ResponsiveContainer>
                      {/* Legend */}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 14,
                        }}
                      >
                        {donutData.map((item) => (
                          <div
                            key={item.name}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 8,
                            }}
                          >
                            <div
                              style={{
                                width: 11,
                                height: 11,
                                borderRadius: "50%",
                                background: item.color,
                                flexShrink: 0,
                              }}
                            />
                            <div>
                              <div style={{ fontSize: 11, color: "#888" }}>
                                {item.name}
                              </div>
                              <div
                                style={{
                                  fontSize: 15,
                                  fontWeight: 700,
                                  color: "#1a1a1a",
                                }}
                              >
                                {item.value}%
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* Categories */}
                  <div>
                    <div>
                      <h5
                        className="dashboard-payment-container-data-section-content-title"
                        style={{ marginTop: 28 }}
                      >
                        {t("categories")}
                      </h5>
                      <p className="registration-container-description">
                        {t("tap to view details")}
                      </p>
                    </div>
                    {barData && barData.length !== 0 && (
                      <AllCategories
                        accountId={this.props.match.params.id}
                        history={history}
                        detailedCategories={barData}
                        fromDate={this.state.fromDate}
                        toDate={this.state.toDate}
                        operationDirection={this.state.operationDirection}
                      />
                    )}
                  </div>
                </div>
              </div>
              <div className="dashboard-payment-container-confirmation-section">
                <div className="dashboard-payment-container-confirmation-section-header">
                  <h3 className="dashboard-payment-container-confirmation-section-header-title">
                    {t("statistics section title")}
                  </h3>
                </div>
                <div className="dashboard-payment-container-confirmation-section-content">
                  <img
                    src={transferConfirmation}
                    className="dashboard-payment-container-confirmation-section-content-image"
                    alt="confirmation-content-image"
                  />
                  <div className="dashboard-payment-container-confirmation-section-content-description">
                    <p>{t("statistics section description")}</p>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </Fragment>
    );
  }
}
export default translate("translation")(JuridicalStatistics);
